import React from 'react'
import { Controller } from 'react-hook-form'
import { Input, Select, TextArea } from '@tecsinapse/cortex-react'
import { MASKS } from '@web/modules/core'
import { formatPaymentValue, orderOptions, PLATFORM } from '@repo/core'
import { useSendOrderMessageFormInfo } from '@repo/core/src/send-order-message/useSendOrderMessageFormInfo'
import { AnalyticsEvents } from '@repo/types/src/enums/AnalyticsEvents'
import { EventGoal, EventOrigin, logEvent } from '@web/analytics'

const SendOrderMessageFormInfo = () => {
  const { item0, type, updatePaymentValue, updateTitle, updatePrice, control } =
    useSendOrderMessageFormInfo()

  logEvent({
    name: AnalyticsEvents.VISUALIZAR_AREA_COBRANCA,
    params: {
      origin: EventOrigin.modal,
      goal: EventGoal.click,
      platform: PLATFORM.WEB
    }
  })

  return (
    <div>
      <div className='bg-white rounded-centi p-deca'>
        <p className='text-centi mb-deca'>Informações da mensagem</p>
        <div className='flex flex-col space-y-deca'>
          <Input.Root
            placeholder='Título da cobrança'
            value={item0.name ?? ''}
            onChange={updateTitle}
            maxLength={60}
          />
          <Controller
            control={control}
            name='type'
            render={({ field: { value, onChange } }) => {
              console.log('TYPE SELECT VALUE =>', value, typeof value)

              return (
                <Select.Root
                  value={orderOptions.find(opt => opt.value === value)}
                  keyExtractor={item => item.value}
                  labelExtractor={item => item.label}
                >
                  <Select.Trigger label='Tipo de cobrança' />

                  <Select.Popover>
                    <Select.Options
                      options={orderOptions}
                      onSelect={opt => onChange(opt.value)}
                    />
                  </Select.Popover>
                </Select.Root>
              )
            }}
          />

          <Controller
            control={control}
            name='text'
            render={({ field: { value, onChange } }) => (
              <TextArea.Root
                onChange={onChange}
                value={value}
                placeholder='Mensagem'
                maxLength={1024}
                rows={8}
              />
            )}
          />
          <Input.Mask
            placeholder='Valor da cobrança'
            value={item0.price}
            mask={MASKS.CURRENCY}
            onChange={updatePrice}
          />
          <Controller
            control={control}
            name='value'
            render={({ field: { value } }) => (
              <Input.Root
                placeholder='Chave pix, link ou boleto'
                value={formatPaymentValue(value, type)}
                onChange={updatePaymentValue}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default SendOrderMessageFormInfo
